/**
 * ChannelRulesEntry – CTA-Button + Dialog-State für den Kanalregeln-Builder
 *
 * Schlanker Einstiegspunkt (≤50 Zeilen), der in MergedProductsPage eingebettet wird.
 */

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/v2/ui'
import { ChannelRulesDialog } from './ChannelRulesDialog'

export function ChannelRulesEntry() {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        data-testid="open-channel-rules"
        onClick={() => setOpen(true)}
      >
        {t('channelRules.openCta')}
      </Button>
      <ChannelRulesDialog open={open} onClose={() => setOpen(false)} />
    </>
  )
}
